import defaultTheme from './defaultTheme';
const walgreensTheme = Object.assign(Object.assign({}, defaultTheme), { link: '#ee0202', button: Object.assign(Object.assign({}, defaultTheme.button), { text: '#ee0202', background: '#ee0202' }), chatIcon: Object.assign(Object.assign({}, defaultTheme.chatIcon), { background: '#ee0202' }), radio: Object.assign(Object.assign({}, defaultTheme.radio), { inactiveBorder: '#ee0202', border: '#ee0202', background: '#ee0202' }), field: {
        focus: '#ee0202',
        label: '#ee0202',
        icon: '#ee0202',
    } });
export default walgreensTheme;
